<template>
  <modal v-model="show"
         max-width="500"
         content-class="modal-info-user"
         :has-padding="false">
    <div class="wrapper"
         key="info-user">
      <div class="modal-info-user-logged"
           v-if="user">
        <div xs3
             class="user-picture">
          <img :src="photo"
               @click="changeAvatar()">

          <button id="pickAvatar"
                  ref="pickAvatar"
                  class="change-picture">{{$t('message.generics.message.changeAvatar')}}</button>
          <avatar-cropper trigger="#pickAvatar"
                          :labels="{ submit: this.$t('message.generics.message.submit'), cancel: this.$t('message.generics.message.cancel')}"
                          :cropper-options="{
                            aspectRatio: 1,
                            autoCropArea: 0.8,
                            viewMode: 1,
                        }"
                          :output-mine="'image/png'"
                          :upload-handler="uploadAvatar" />
        </div>

        <div class="user-info">
          <h2>{{user.nome}}</h2>
          <h5>{{user.login}}</h5>

          <div class="card-footer">
            <!-- <button tag="button"
                    @click="settings"
                    class="btn btn-primary btn-round">
                {{$t('message.generics.message.settings')}}
            </button> -->

            <router-link to="/logout"
                         tag="button"
                         class="btn btn-secondary btn-round">
              {{$t('message.generics.message.logout')}}
            </router-link>
          </div>
        </div>
      </div>

      <div class="modal-info-user-admin"
           v-if="!user">
        <div class="user-picture">
          <img :src="avatar">
        </div>
        <div class="user-info">
          <h2>{{$t('message.generics.message.admin')}}</h2>
          <div class="card-footer">

            <router-link to="/logout"
                         tag="button"
                         class="btn btn-secondary btn-round">
              {{$t('message.generics.message.logout')}}
            </router-link>
          </div>
        </div>
      </div>

    </div>
  </modal>
</template>

<script>
import EventBus from "@packages/event-bus";
import AvatarCropper from "vue-avatar-cropper";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    AvatarCropper,
    Modal,
  },

  data() {
    return {
      show: false,
      // avatar: null,
      logo: null,
      headersUploadFile: {
        Authorization: localStorage.getItem("token"),
      },
    };
  },

  props: {
        avatar: {
            type: String,
        }
  }, 

  computed: {
    isMasterUser() {
      return this.user.permissions.includes("MASTER");
    },
    user() {
      return this.$store.state.users.user;
    },
    admin() {
      return this.$store.state.users.admin;
    },
    isEstabelecimento() {
      return this.$store.state.users.user.tipo === "ESTABELECIMENTO";
    },
    photo() {
      return this.avatar
    }   
  },
  
  methods: {
    async uploadAvatar(cropper) {
      const imgData = cropper.getCroppedCanvas().toDataURL("image/png");

      if (imgData) {
        EventBus.$emit("SHOW_SPINNER");

        const file = this.dataURLtoFile(imgData, "avatar.png");

        let formData = new FormData();
        formData.append("file", file);

        try {
          await this.$api.userLogin.uploadAvatar({ data: formData });

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t("message.successMessages.message.avatarUpdated"),
          });

          this.handleUploadedAvatar(imgData);
        } catch (error) {
          console.log(error);
        } finally {
          EventBus.$emit("CANCEL_SPINNER");
        }
      }
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    settings() {
      this.show = false;
      this.$router.push({ path: `/configuracoes` });
    },
    changeAvatar() {
      this.$refs.pickAvatar.click();
    },
    handleUploadedAvatar(avatar) {
      this.$store.commit("SET_AVATAR", avatar);
      EventBus.$emit("CHANGE-AVATAR", avatar);
    },
    viewUserInfoHandler() {      
      this.show = true;
    }    
  },
  async mounted() {
    EventBus.$on("VIEW-USER-INFO", this.viewUserInfoHandler);
  },
  beforeDestroy() {
    EventBus.$off("VIEW-USER-INFO", this.viewUserInfoHandler);
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.modal-info-user-logged,
.modal-info-user-admin {
  display: flex;
}

.wrapper {
  padding: 10px;
}

.card-footer {
  display: flex;
  align-items: center;
  padding-bottom: 5px;

  .btn {
    margin: 5px;
  }
}

.modal-round .v-card .card-body {
  min-height: 200px;
}

.user-info {
  padding-left: 10px;
}

.user-picture {
  display: flex;
  flex-direction: column;
  margin-top: auto;
  margin-bottom: auto;

  cursor: pointer;

  &.user-picture_logo {
    img {
      background: $primary;
      padding: 10px;
    }
  }
}

.user-picture img {
  cursor: pointer;
  max-width: 90px;
  max-height: 90px;
}

.column {
  display: block;
}

h2 {
  font-size: 1.8rem;
  font-weight: 700;
  text-align: left;
}

h5 {
  text-align: left;
}

.change-picture {
  font-size: 1.3rem;
}
</style>
